export default "__VITE_ASSET__fcaOTq6n__"